import React, { Component, ReactNode } from 'react'
import Tippy from '@tippyjs/react'
import 'tippy.js/dist/tippy.css'
import './Tooltip.css'

interface Props {
  text: string
  truncate?: true
  children: ReactNode
}

export default class Tooltip extends Component<Props> {
  render () {
    const { text, children, truncate } = this.props
    const className = truncate ? 'truncate' : 'inline-block'
    return text
      ? (
        <Tippy content={text}>
          <div className={className}>
            {children}
          </div>
        </Tippy>
        )
      : children
  }
}
